import NetworkCall from "network/networkCall";
import Request from "network/request";

export class ClientReportConfigs {
  static async create(clientId, data, useLoading = true) {
    return NetworkCall.fetch(
      Request.v2.createClientReportConfig(clientId, data),
      useLoading,
      false,
    );
  }

  static async update(clientId, data, useLoading = true) {
    return NetworkCall.fetch(
      Request.v2.updateClientReportConfig(clientId, data),
      useLoading,
      false,
    );
  }

  static async getAll(params, useLoading = true) {
    return NetworkCall.fetch(
      Request.v2.getClientReportConfigs(params),
      useLoading,
      false,
    );
  }
}
